<template>
  <div>
    <v-card flat class="mb-5">
      <v-card-text class="black--text">
        <v-container class="pa-5">
          <div class="mb-5">
            <h2>1. Unduh Template File PDF</h2>
            <v-alert text dense color="info" class="mb-0 mt-1">
              <v-row class="black--text">
                <v-col class="my-auto" cols="12" md="9">
                  Berikut adalah Template File PDF yang digunakan untuk pengisian berkas berita acara cetak
                </v-col>
                <v-col cols="12" md="3" class="text-right">
                  <v-btn
                    color="success"
                    class="elevation-1 text-capitalize"
                    @click="onDownload"
                    :disabled="
                      type === 'dokumen' && +pspPeringkat.k_tahap_peringkat_psp === 10 && +pspPeringkat.is_revisi === 1
                    "
                  >
                    <v-icon left>
                      mdi-download
                    </v-icon>
                    Unduh Template
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </div>
          <div class="mb-5">
            <h2>2. Lakukan Verifikasi Berkas</h2>
            <p class="black--text mt-1">
              Lakukan pengisian tanda tangan beserta stempel basah dari pihak yang bersangkutan dalam dokumen tersebut.
            </p>
          </div>
          <div class="mb-5">
            <h2>3. Unggah File PDF Hasil Verifikasi Berkas</h2>
            <v-row class="mt-1">
              <v-col cols="12" class="py-0">
                <div class="px-0 body-2 grey--text text--darken-1">
                  Unggah Template Berita Acara Kepala Sekolah (format file .pdf)
                </div>
              </v-col>
              <v-col v-if="!berkasBa" cols="3" class="flex-grow-1 flex-shrink-0 my-auto py-1">
                <v-btn
                  color="success"
                  elevation="1"
                  @click="onUpload"
                  :disabled="!$allow(`psp-peringkat-dinas.ba-upload${type === 'revisi' ? '-revisi' : ''}`)"
                >
                  <v-icon color="white" left>
                    mdi-upload
                  </v-icon>
                  Unggah Berkas
                </v-btn>
              </v-col>
              <v-col
                v-if="isEditBa"
                cols="12"
                sm="12"
                md="2"
                class="flex-grow-1 flex-shrink-0 my-auto py-1"
                style="max-width: 180px"
              >
                <v-btn
                  dark
                  color="green"
                  elevation="1"
                  @click="onUpload"
                  :disabled="!$allow('psp-peringkat-dinas.ba-upload')"
                >
                  <v-icon color="white">
                    mdi-pencil
                  </v-icon>
                  Ubah Berkas
                </v-btn>
              </v-col>
              <v-col v-if="berkasBa" cols="12" sm="12" md="2" class="flex-grow-1 flex-shrink-0 my-auto py-1">
                <v-btn dark color="primary" elevation="1" :href="berkasBa" target="_blank">
                  <v-icon left>
                    mdi-eye
                  </v-icon>
                  Lihat Berkas
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <popup-upload ref="upload" :type="type" @save="onUploadSave" />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import PopupUpload from '../popup/Unggah';
export default {
  components: { PopupUpload },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState('peringkat', {
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),

    berkasBa() {
      if (this.type === 'revisi') {
        return this.pspPeringkat.url_ba_revisi || '';
      }

      return this.pspPeringkat.url_ba || '';
    },

    isEditBa() {
      if (this.type === 'revisi') {
        return this.pspPeringkat.file_ba_revisi || '';
      }

      return this.pspPeringkat.file_ba && [6, 9].includes(this.pspPeringkat.k_tahap_peringkat_psp);
    },
  },
  methods: {
    ...mapActions('peringkat', ['download', 'save']),

    reset() {},

    onDownload() {
      const type = this.type === 'revisi' ? 'ba-template-revisi' : 'ba-template';
      this.download({ type }).then((url) => {
        window.open(url, '_blank');
      });
    },

    onUpload() {
      this.$refs.upload.open();
    },

    onUploadSave(file) {
      const type = this.type === 'revisi' ? 'ba-upload-revisi' : 'ba-upload';
      const formData = new FormData();
      formData.append('file', file);

      this.save({ type, params: formData, upload: true }).then(() => {
        this.$success('Berkas BA berhasil diunggah');
        this.$emit('reload');
        this.$refs.upload.close();
      });
    },
  },
};
</script>
